<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion-carta'}">{{$t('configuracionCarta')}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'formas-de-pago-carta'}">{{$t('formasDePagoCarta')}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t('formaDePagoCarta')}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="nombreCategoria"><strong>{{$t('nombre')}}</strong> <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control"
                                       id="nombreCategoria"
                                       v-model="formaPago.nombre" maxlength="127">
                                <em>
                                    <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, formaPago.nombre.length) }}</span>
                                </em>
                            </div>
                        </div>
                        <div class="col-md-2" v-if="!formaPago.default">
                            <div class="form-group">
                                <label for="formaPagoRelacionada"><strong>{{$t('formaDePago')}} TPV</strong></label>
                                <el-select
                                    class="select-default"
                                    size="large"
                                    v-model="formaPago.idFormaPagoTPV"
                                    filterable
                                    :placeholder="'Seleccione una forma de pago del TPV'"
                                >
                                    <el-option
                                        v-for="formaPago in listFormaPagoTPV"
                                        class="select-primary"
                                        :value="formaPago.id"
                                        :label="formaPago.name"
                                        :key="formaPago.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <!--v-if="formaPago.tieneSinqro && formaPago.methodCodeSinqro"-->
                        <div class="col-md-4" v-if="formaPago.tieneSinqro">
                            <div class="form-group">
                                <label for="formaPagoRelacionada"><strong>{{$t('metodoLiquidacionSinqro')}}</strong></label>
                                <input type="text" class="form-control"
                                       v-model="formaPago.methodCodeSinqro">
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>
                                    <strong>{{$t("baja")}}</strong>
                                </label>
                                <el-switch v-model="formaPago.baja"
                                           active-color="#13ce66"
                                           inactive-color="#bcbcbc">
                                </el-switch>

                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary" @click="saveFormaPago()"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>
                            <router-link :to="{name:'formas-de-pago-carta'}">
                            <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{$t("cancelar")}}
                            </button>
                            </router-link>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Switch} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        name: "FormaPagoCarta",
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Switch.name]: Switch
        },
        data() {
            return {
                idFormaPago: this.$route.params.idFormaPago,
                idBusiness: this.$route.params.idBusiness,
                action: '',

                formaPago: {
                    nombre: "",
                    baja:false,
                    descripcion: "",
                    default: true,
                    idFormaPagoTPV: 0,
                    orden: 999,
                    methodCodeSinqro: "",
                    tieneSinqro: false,
                },
                listFormaPagoTPV: [],
            }
        },
        created() {

            this.action = this.idFormaPago ? this.$i18n.t("editar") : this.$i18n.t("nuevo");

            this.getListFormasPagoTPV();

            if (this.idFormaPago) {
                this.getFormaPagoCarta();
            } else {
                this.formaPago.default = false;
            }
        },
        methods: {
            calculateNumberOfCharacters(total, lenght) {
                return total - lenght;
            },

            getFormaPagoCarta() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        idFormaPago: this.idFormaPago
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "delivery/getFormaPagoCartaById", config)
                    .then(function (response) {
                        if (response.data.response) {

                            if ((response.data.result.nombre == "Tarjeta" && response.data.result.codigo == "T") || response.data.result.codigo == "E") 
                                response.data.result.default = true;

                            vm.formaPago = response.data.result;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            },
            getListFormasPagoTPV() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "delivery/getFormasPagoTpv", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listFormaPagoTPV = response.data.result;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            saveFormaPago() {

                if (this.checkFormaPago()) {

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt,

                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        formaPago: this.formaPago,
                        jwt: this.$store.getters.jwt,
                    };

                    let vm = this;
                    let controller = this.idFormaPago ? "editarFormaPagoCarta" : "saveFormaPagoCarta";
                    this.axios.post(this.$store.getters.apiUrl + 'delivery/' + controller, params, config)
                        .then(function (response) {
                            if (response.data.response) {

                                vm.$router.push({name: 'formas-de-pago-carta', params: {idBusiness: vm.idBusiness}})


                                let notify = vm.$t("editada");
                                vm.$notify({
                                    message: vm.$t('categoria')+ ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });


                }
            },
            checkFormaPago() {

                var check = true;

                if (this.formaPago.nombre === "") {

                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneLosCamposObligatorios'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    check = false;
                }

                return check;


            }

        },
    }
</script>

<style scoped>

    .card {
        padding: 20px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/FormasPago/FormaPagoCarta.vue